import { hot } from 'react-hot-loader/root';
import { lazy } from 'react';

const ShopgateCommerceWidgetsImage = lazy(() => import('Image'))

const ShopgateCommerceWidgetsImageSlider = lazy(() => import('ImageSlider'))

const ShopgateCommerceWidgetsHtml = lazy(() => import('Html'))

const ShopgateCommerceWidgetsProductSlider = lazy(() => import('ProductSlider'))

const ShopgateCommerceWidgetsCategoryList = lazy(() => import('CategoryList'))

const ShopgateCommerceWidgetsProductList = lazy(() => import('Products'))

const ShopgateCommerceWidgetsLiveshopping = lazy(() => import('Liveshopping'))

const ShopgateCommerceWidgetsDropdownNavigation = lazy(() => import('NestedCategoryFilter'))

export default {
  '@shopgate/commerce-widgets/image': hot(ShopgateCommerceWidgetsImage),
  '@shopgate/commerce-widgets/image_slider': hot(ShopgateCommerceWidgetsImageSlider),
  '@shopgate/commerce-widgets/html': hot(ShopgateCommerceWidgetsHtml),
  '@shopgate/commerce-widgets/product_slider': hot(ShopgateCommerceWidgetsProductSlider),
  '@shopgate/commerce-widgets/category_list': hot(ShopgateCommerceWidgetsCategoryList),
  '@shopgate/commerce-widgets/product_list': hot(ShopgateCommerceWidgetsProductList),
  '@shopgate/commerce-widgets/liveshopping': hot(ShopgateCommerceWidgetsLiveshopping),
  '@shopgate/commerce-widgets/dropdown_navigation': hot(ShopgateCommerceWidgetsDropdownNavigation),
};
